import { InputLabel } from "@material-ui/core"
import styled from "styled-components"

export const StyledInputLabel = styled(InputLabel)`
            font-size: 10pt;
            text-align: right;
            color: rgb(63, 80, 97); 
  `;

